import { Videocam, VideocamOff } from '@mui/icons-material';
import { RoundButton } from '@ysura/common';

import { useInteraction } from '@/hooks';

type ToggleCameraButtonProps = {
  size?: 'large' | 'medium' | 'small';
};

export const ToggleCameraButton = ({
  size = 'large',
}: ToggleCameraButtonProps) => {
  const { isCameraActive, cameraPermissionState, setIsCameraActive } =
    useInteraction();

  const toggleCamera = () => {
    setIsCameraActive?.(!isCameraActive);
  };

  return (
    <RoundButton
      size={size}
      variant="secondary"
      inactive={!isCameraActive}
      disabled={cameraPermissionState !== 'granted'}
      testId="camera-button"
      onClick={toggleCamera}
    >
      {cameraPermissionState === 'granted' && isCameraActive ? (
        <Videocam />
      ) : (
        <VideocamOff />
      )}
    </RoundButton>
  );
};
